import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GeneralSettings from '../../components/EmailSettings/GeneralSettings';
import DomainSettings from '../../components/EmailSettings/DomainSettings';
import ApiKeysSettings from '../../components/EmailSettings/ApiKeysSettings';

const EmailTab: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState<string>('general');

  React.useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && ['general', 'domains', 'apikeys'].includes(hash)) {
      setActiveTab(hash);
    }
  }, [location.hash]);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    navigate(`${location.pathname}#${tab}`);
  };

  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-1 gap-6">
        <div className="col-span-1">
          <div className="border-b border-gray-200 mb-6">
            <nav className="flex space-x-8" aria-label="Email Settings Tabs">
              <button
                onClick={() => handleTabChange('general')}
                className={`py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'general'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
              >
                General
              </button>
              <button
                onClick={() => handleTabChange('domains')}
                className={`py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'domains'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
              >
                Domains
              </button>
              <button
                onClick={() => handleTabChange('apikeys')}
                className={`py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'apikeys'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
              >
                API Keys
              </button>
            </nav>
          </div>

          {activeTab === 'general' && <GeneralSettings />}
          {activeTab === 'domains' && <DomainSettings />}
          {activeTab === 'apikeys' && <ApiKeysSettings />}
        </div>
      </div>
    </div>
  );
};

export default EmailTab; 